import React, { useEffect, useState, useRef, useContext } from "react";
import ComparisonItem from "./comparison-item";
import { AppSettings } from "../../config/app-settings";
import PhotoSwipeLightbox from "photoswipe/lightbox";
function MachineList() {
  const context = useContext(AppSettings);
  useEffect(() => {
    context.setAppContentFullHeight(true);
    context.setAppContentClass("p-0");
    context.setAppSidebarCollapsed(true);

    var lightbox;

    if (!lightbox) {
      lightbox = new PhotoSwipeLightbox({
        gallery: ".gallery-image-list",
        children: "a",
        pswpModule: () => import("photoswipe"),
      });
      lightbox.init();
    }

    return function cleanUp() {
      context.setAppContentFullHeight(false);
      context.setAppContentClass("");
      context.setAppSidebarCollapsed(false);

      if (lightbox) {
        lightbox.destroy();
        lightbox = null;
      }
    };

    // eslint-disable-next-line
  }, []);
  return (
    <div style={{ padding: "40px" }}>
      <h4 style={{ textAlign: "center" }}>Machine Comparison</h4>
      <div className="row justify-content-center">
        <div className="col-12 col-md-6">
          <ComparisonItem></ComparisonItem>
        </div>
        <div className="col-12 col-md-6">
          <ComparisonItem></ComparisonItem>
        </div>
      </div>
    </div>
  );
}

export default MachineList;
